export default __webpack_public_path__ + "static/media/1499.6bae0cd4.png";